// Mock data for Mehta Associates Property Valuation Website

export const companyInfo = {
  name: "Mehta Associates",
  tagline: "Government Registered & Approved Property Valuer",
  description: "Trusted Valuation Services Across Gujarat",
  experience: "15+ Years",
  address: "404, Sapphire Prime, Opp. Daxina Murti School, Waghawadi Road, Bhavnagar – 364002",
  mobile: "96629 46399",
  // alternateMobile: "93777 61969",
  email: "valuermehta@yahoo.com",
  proprietor: {
    name: "Ajay Champaklal Mehta",
    designation: "Govt. Registered & Approved Valuer",
    qualifications: [
      "Master of Valuation (Real Estate & Agriculture Land)",
      "Registered Valuer under Income Tax Act 34AB",
      "RVO Certified (Land & Building, Agriculture Land)",
      "Member, Council of Engineers & Valuers"
    ],
    categories: ["CAT-I: Land & Building", "CAT-II: Agriculture Land"]
  }
};

export const services = [
  {
    "id": 1,
    "title": "Fair Market Valuation",
    "description": "Valuation based on the price a willing buyer and seller would agree upon in an open market.",
    "icon": "Scale"
  },
  {
    "id": 2,
    "title": "Forced Sale Valuation",
    "description": "Valuation under conditions where the property must be sold quickly, usually at a lower price.",
    "icon": "AlertTriangle"
  },
  {
    "id": 3,
    "title": "Distress Valuation",
    "description": "Valuation when the seller is under financial stress, resulting in a reduced value.",
    "icon": "Triangle"
  },
  {
    "id": 4,
    "title": "Going Concern Valuation",
    "description": "Valuation of a business assuming continued operation, including goodwill and future earnings.",
    "icon": "BriefcaseBusiness"
  },
  {
    "id": 5,
    "title": "Book Valuation",
    "description": "Valuation based on the asset's value recorded in company accounting books.",
    "icon": "Book"
  },
  {
    "id": 6,
    "title": "Breakup Valuation",
    "description": "Valuation of individual components of a business if sold separately.",
    "icon": "Split"
  },
  {
    "id": 7,
    "title": "Annual Rent Valuation",
    "description": "Valuation based on the property's annual rental income potential.",
    "icon": "Receipt"
  },
  {
    "id": 8,
    "title": "Liquidation Valuation",
    "description": "Valuation under immediate sale conditions, generally lowest due to urgency.",
    "icon": "Banknote"
  },
  {
    "id": 9,
    "title": "Potential Valuation",
    "description": "Valuation based on future growth potential and development opportunities.",
    "icon": "TrendingUp"
  },
  {
    "id": 10,
    "title": "Replacement Valuation",
    "description": "Valuation based on the cost to replace the asset with a new equivalent.",
    "icon": "RefreshCcw"
  },
  {
    "id": 11,
    "title": "Scrap Valuation",
    "description": "Valuation of the asset when it is sold only as scrap material.",
    "icon": "Trash2"
  },
  {
    "id": 12,
    "title": "Salvage Valuation",
    "description": "Valuation of usable parts or value remaining after the asset is damaged or obsolete.",
    "icon": "Wrench"
  },
  {
    "id": 13,
    "title": "Statutory Valuation",
    "description": "Valuation done as per government laws, rules, or regulatory guidelines.",
    "icon": "ShieldCheck"
  },
  {
    "id": 14,
    "title": "Stigma Valuation",
    "description": "Valuation impacted due to negative history or psychological perception.",
    "icon": "AlertOctagon"
  }
]


export const whyChooseUs = [
  {
    id: 1,
    title: "Accurate Valuation",
    description: "Based on latest market trends, survey reports, and government guidelines.",
    icon: "Target"
  },
  {
    id: 2,
    title: "Legal Compliance",
    description: "All valuations follow Gujarat Government, Income Tax, and Wealth Tax Act norms.",
    icon: "Shield"
  },
  {
    id: 3,
    title: "Transparent Reporting",
    description: "Unbiased, well-documented, industry-standard valuation reports.",
    icon: "FileCheck"
  },
  {
    id: 4,
    title: "Recognized & Empanelled",
    description: "Approved by major banks including SBI, Bank of Baroda, Indian Bank, PNB, and more.",
    icon: "Award"
  },
  {
    id: 5,
    title: "Financial Support",
    description: "Useful for home loans, mortgage loans, balance transfer, project finance, and legal disputes.",
    icon: "DollarSign"
  },
  {
    id: 6,
    title: "Expert Market Insights",
    description: "Backed by qualified valuation knowledge with Master of Valuation degree and RVO membership.",
    icon: "TrendingUp"
  }
];

export const banks = [
  "Bhavnagar Nagrik Sahkari Bank",
  "Ceejay Finance Ltd.",
  "Gujarat Gramin Bank (Old name: Saurashtra Gramin Bank)",
  "Sihor Mercantile Co-Op Bank Ltd.",
  "Sihor Nagrik Sahkari Bank Ltd.",
  "State Bank of India",
  "Citizen Co-Op Bank Ltd.",
  "Indian Bank",
  "UCO Bank",
  "Bank of Baroda",
  "Punjab National Bank (Gujarat)",
  "Punjab National Bank (Maharashtra)",
  "Federal Bank",
  "Karnataka Bank",
  "Indian Overseas Bank",
  "Union Bank of India",
];

export const valuationProcess = [
  {
    step: 1,
    title: "Inquiry",
    description: "Submit required documents including ownership proof (Property Tax Bill/Land Record/Sale Deed) and owner ID (Aadhar & PAN Card).",
    icon: "FileText"
  },
  {
    step: 2,
    title: "Confirmation of Value",
    description: "We prepare a draft valuation based on applicable rates and send it to you. Request corrections if needed.",
    icon: "Edit"
  },
  {
    step: 3,
    title: "Final Report",
    description: "Get the signed & sealed government-approved valuation report. Instant scan copy + same-day courier dispatch.",
    icon: "CheckCircle"
  }
];

export const priceTrends = [
  {
    id: 1,
    category: "Agriculture Land",
    surveyMonth: "January 2025",
    fiscalYear: "FY 2025-26",
    data: [
      { district: "Bhavnagar", avgPrice: "₹15-25 Lakh/Bigha", change: "+8%" },
      { district: "Ahmedabad", avgPrice: "₹35-50 Lakh/Bigha", change: "+12%" },
      { district: "Rajkot", avgPrice: "₹20-30 Lakh/Bigha", change: "+10%" },
      { district: "Surat", avgPrice: "₹40-60 Lakh/Bigha", change: "+15%" },
      { district: "Vadodara", avgPrice: "₹25-35 Lakh/Bigha", change: "+9%" }
    ]
  },
  {
    id: 2,
    category: "Urban Land",
    surveyMonth: "February 2025",
    fiscalYear: "FY 2025-26",
    data: [
      { district: "Bhavnagar", avgPrice: "₹8,000-15,000/Sq.Yd", change: "+7%" },
      { district: "Ahmedabad", avgPrice: "₹25,000-45,000/Sq.Yd", change: "+11%" },
      { district: "Rajkot", avgPrice: "₹12,000-22,000/Sq.Yd", change: "+9%" },
      { district: "Surat", avgPrice: "₹30,000-55,000/Sq.Yd", change: "+14%" },
      { district: "Vadodara", avgPrice: "₹15,000-28,000/Sq.Yd", change: "+10%" }
    ]
  },
  {
    id: 3,
    category: "Building/House with Land",
    surveyMonth: "March 2025",
    fiscalYear: "FY 2025-26",
    data: [
      { district: "Bhavnagar", avgPrice: "₹35-60 Lakh", change: "+6%" },
      { district: "Ahmedabad", avgPrice: "₹80-150 Lakh", change: "+10%" },
      { district: "Rajkot", avgPrice: "₹50-85 Lakh", change: "+8%" },
      { district: "Surat", avgPrice: "₹90-180 Lakh", change: "+13%" },
      { district: "Vadodara", avgPrice: "₹60-110 Lakh", change: "+9%" }
    ]
  },
  {
    id: 4,
    category: "Flats/Apartments",
    surveyMonth: "April 2025",
    fiscalYear: "FY 2025-26",
    data: [
      { district: "Bhavnagar", avgPrice: "₹2,800-4,200/Sq.Ft", change: "+5%" },
      { district: "Ahmedabad", avgPrice: "₹4,500-7,500/Sq.Ft", change: "+9%" },
      { district: "Rajkot", avgPrice: "₹3,200-5,000/Sq.Ft", change: "+7%" },
      { district: "Surat", avgPrice: "₹5,000-8,500/Sq.Ft", change: "+12%" },
      { district: "Vadodara", avgPrice: "₹3,800-6,000/Sq.Ft", change: "+8%" }
    ]
  },
  {
    id: 5,
    category: "Shops/Commercial",
    surveyMonth: "January 2025",
    fiscalYear: "FY 2025-26",
    data: [
      { district: "Bhavnagar", avgPrice: "₹4,500-7,000/Sq.Ft", change: "+6%" },
      { district: "Ahmedabad", avgPrice: "₹8,000-15,000/Sq.Ft", change: "+11%" },
      { district: "Rajkot", avgPrice: "₹5,500-9,000/Sq.Ft", change: "+8%" },
      { district: "Surat", avgPrice: "₹9,000-18,000/Sq.Ft", change: "+13%" },
      { district: "Vadodara", avgPrice: "₹6,500-11,000/Sq.Ft", change: "+9%" }
    ]
  }
];

export const certificates = [
  {
    id: 1,
    title: "Registered Valuer Certificate (U/s 34AB)",
    description:
      "Registered as Approved Valuer under Section 34AB of the Wealth Tax Act, 1957 for Immovable Property. Registration No: CAT-1/756/2022-23. Issued by Office of Chief Commissioner of Income Tax, Ahmedabad (18/07/2022).",
    category: "Government Registration",
    year: "2022"
  },
  {
    id: 2,
    title: "IIV Membership – CAT-I (Immovable Property)",
    description:
      "Approved Valuer – Immovable Property. The Indian Institution of Valuers (India). Membership No: CAT-I-A-5765. Dated: 10 April 2020.",
    category: "Professional Membership",
    year: "2020"
  },
  {
    id: 3,
    title: "IIV Membership – CAT-II (Agricultural Land)",
    description:
      "Approved Valuer – Agricultural Land. The Indian Institution of Valuers (India). Membership No: CAT-II-A-6605. Dated: 12 January 2023.",
    category: "Professional Membership",
    year: "2023"
  },
  {
    id: 4,
    title: "Council of Engineers & Valuers (CEV)",
    description:
      "Life Member – Council of Engineers & Valuers. Membership No: CEV/SM/1874/MV RE. Certified Valuer for professional valuation practice.",
    category: "Professional Membership",
    year: "2021"
  },
  {
    id: 5,
    title: "Certificate of Practice (COP)",
    description:
      "Certificate of Practice issued by The Indian Institution of Valuers. CP No: 302. Valid from 28 January 2023.",
    category: "Professional Certification",
    year: "2023"
  },
  {
    id: 6,
    title: "Educational Qualification Certificate",
    description:
      "Master of Commerce – Valuation of Real Estate & Agriculture Land. Gujarat University (March 2019).",
    category: "Educational Qualification",
    year: "2019"
  },
  {
    id: 7,
    title: "Professional Experience Certificate",
    description:
      "Experience as Assistant Valuer at S.J. Asset Appraisal Pvt. Ltd. (April 2018 – March 2022) with exposure to major banking institutions.",
    category: "Experience",
    year: "2018–2022"
  }
];


export const faqs = [
  {
    id: 1,
    question: "What documents are required for property valuation?",
    answer: "You need to submit ownership proof (Property Tax Bill, Land Record, or Sale Deed) and owner ID proof (Aadhar Card and PAN Card)."
  },
  {
    id: 2,
    question: "How long does the valuation process take?",
    answer: "We provide confirmation value reports within 24 hours of receiving complete documentation. Final signed reports are delivered on the same day via scan copy and courier."
  },
  {
    id: 3,
    question: "Is the valuation report legally valid?",
    answer: "Yes, our valuation reports are government-approved and legally valid for Income Tax, Wealth Tax, bank loans, legal disputes, and all official purposes."
  },
  {
    id: 4,
    question: "Which banks accept your valuation reports?",
    answer: "Our reports are accepted by major banks including SBI, Bank of Baroda, Indian Bank, PNB, UCO Bank, and many other nationalized and private banks."
  },
  {
    id: 5,
    question: "What areas do you cover?",
    answer: "We provide valuation services across Gujarat, with detailed market analysis for Bhavnagar, Ahmedabad, Rajkot, Surat, Vadodara, and other districts."
  },
  {
    id: 6,
    question: "What types of properties do you value?",
    answer: "We value all types of properties including residential homes, agriculture land, commercial buildings, industrial properties, flats, apartments, shops, and development projects."
  }
];

export const heroImages = {
  office: [
    "https://images.unsplash.com/photo-1497366811353-6870744d04b2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBvZmZpY2V8ZW58MHx8fHwxNzY5NjI2ODc2fDA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1497366754035-f200968a6e72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBvZmZpY2V8ZW58MHx8fHwxNzY5NjI2ODc2fDA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1746021375246-7dc8ab0583f0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjB3b3Jrc3BhY2V8ZW58MHx8fHwxNzY5NjI2ODgxfDA&ixlib=rb-4.1.0&q=85"
  ],
  property: [
    "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwyfHxyZWFsJTIwZXN0YXRlfGVufDB8fHx8MTc2OTU4MTMwNHww&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1582407947304-fd86f028f716?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwxfHxyZWFsJTIwZXN0YXRlfGVufDB8fHx8MTc2OTU4MTMwNHww&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1605146769289-440113cc3d00?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHw0fHxyZWFsJTIwZXN0YXRlfGVufDB8fHx8MTc2OTU4MTMwNHww&ixlib=rb-4.1.0&q=85"
  ]
};
